import { render, staticRenderFns } from "./editorVideo.vue?vue&type=template&id=66add8c5&scoped=true"
import script from "./editorVideo.vue?vue&type=script&lang=js"
export * from "./editorVideo.vue?vue&type=script&lang=js"
import style0 from "./editorVideo.vue?vue&type=style&index=0&id=66add8c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66add8c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66add8c5')) {
      api.createRecord('66add8c5', component.options)
    } else {
      api.reload('66add8c5', component.options)
    }
    module.hot.accept("./editorVideo.vue?vue&type=template&id=66add8c5&scoped=true", function () {
      api.rerender('66add8c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tinymce/components/editorVideo.vue"
export default component.exports